module.exports = __webpack_public_path__ + "media/audio4.5e81fdb3.mp3";